import React from 'react';
import './Skills.css';
import { FaReact, FaNodeJs, FaAws } from 'react-icons/fa';
import { 
    SiMongodb, 
    SiTypescript, 
    SiDocker, 
    SiMysql, 
    SiSocketdotio, 
    SiExpress, 
    SiTailwindcss, 
    SiRedis 
} from 'react-icons/si';

import { skillDomains as baseSkillDomains } from '../data/skillsData';

const domainIcons = {
    frontend: <FaReact className="domain-icon react" />,
    backend: <FaNodeJs className="domain-icon node" />,
    cloud: <FaAws className="domain-icon aws" />,
    data: <SiMongodb className="domain-icon mongo" />,
};

const techIcons = {
    'React': <FaReact />,
    'Next.js': <FaReact />,
    'TypeScript': <SiTypescript />,
    'Tailwind CSS': <SiTailwindcss />,
    'Node.js': <FaNodeJs />,
    'Express.js': <SiExpress />,
    'WebSockets': <SiSocketdotio />,
    'AWS (EC2/S3/CloudFront)': <FaAws />,
    'Docker': <SiDocker />,
    'MongoDB Atlas': <SiMongodb />,
    'MySQL': <SiMysql />,
    'Redis Caching': <SiRedis />,
};

const skillDomains = baseSkillDomains.map((d) => ({
    ...d,
    icon: domainIcons[d.id] || null,
    technologies: d.technologies.map((tech) => (
        typeof tech === 'string'
            ? { name: tech, icon: techIcons[tech] || null }
            : tech
    )),
}));

const Skills = () => {
    return (
        <section className="skills-section" id="skills">
            <div className="cyber-grid"></div>
            <div className="section-container">
                <div className="section-header">
                    <span className="section-badge">SKILLS &amp; EXPERTISE</span>
                    <h2 className="section-title">Core Engineering Competencies</h2>
                    <p className="section-subtitle">
                        Categorized technical capabilities, production-hardened toolchains, and architectural patterns applied across distributed cloud backends, resilient data tiers, and scalable client platforms.
                    </p>
                </div>

                <div className="skills-domains-grid">
                    {skillDomains.map((domain) => (
                        <div className={`domain-card ${domain.id}`} key={domain.id}>
                            <div className="domain-card-header">
                                <div className="domain-icon-wrap">
                                    {domain.icon}
                                </div>
                                <div className="domain-header-meta">
                                    <span className="domain-badge">{domain.badge}</span>
                                    <h3 className="domain-title">{domain.title}</h3>
                                </div>
                            </div>

                            <p className="domain-desc">{domain.description}</p>

                            {domain.competencies && (
                                <ul className="domain-competency-list">
                                    {domain.competencies.map((comp, cIdx) => (
                                        <li key={cIdx} className="domain-competency-item">
                                            <span className="competency-bullet">▹</span>
                                            <span className="competency-text">
                                                {typeof comp === 'string' ? (
                                                    comp
                                                ) : (
                                                    <>
                                                        <strong className="competency-label">{comp.label}:</strong> {comp.detail}
                                                    </>
                                                )}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            )}


                            <div className="domain-tech-pills">
                                {domain.technologies.map((tech, idx) => (
                                    <span className="domain-tech-pill" key={idx}>
                                        {tech.icon ? (
                                            <span className="tech-pill-icon">{tech.icon}</span>
                                        ) : (
                                            <span className="tech-pill-hash">#</span>
                                        )}
                                        <span>{tech.name}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;